module.exports = __webpack_public_path__ + "img/vision.3ce70c0e.png";